import { useState, type ReactNode } from 'react';
import { useLang, useT, type MessageKey } from '../../i18n';
import s from '../../app/Shell.module.css';

export function PanelSection({
  title,
  children,
  defaultOpen = false,
  help,
}: {
  title: MessageKey;
  children?: ReactNode;
  defaultOpen?: boolean;
  /** Help page slug (public/help/<lang>/<slug>.html). */
  help?: string;
}) {
  const t = useT();
  const lang = useLang((l) => l.lang);
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section className={s.section}>
      <button
        className={s.sectionHead}
        aria-expanded={open}
        onClick={() => setOpen(!open)}
        aria-label={`${t(title)}: ${t(open ? 'collapse' : 'expand')}`}
      >
        <span>{t(title)}</span>
        <span aria-hidden="true">{open ? '−' : '+'}</span>
      </button>
      {open && (
        <div className={s.sectionBody}>
          {help && (
            <a
              href={`/help/${lang}/${help}.html`}
              target="_blank"
              rel="noreferrer"
              aria-label={t('helpTopic', { topic: t(title) })}
              style={{ float: 'right', fontSize: 12, marginLeft: 6 }}
            >
              ?
            </a>
          )}
          {children}
        </div>
      )}
    </section>
  );
}
